'use client'

import React, { useState } from 'react'
import { useRef } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperType } from 'swiper'
import 'swiper/css';
import moment, { Moment } from 'moment';


const CalendarDatesSlider = ({ today, startDay, setTargetDate, events }) => {
    const swiperRef = useRef<SwiperType>()
    const [selectedDate, setSelectedDate] = useState(null)
    const totalDays = 35
    const day = startDay.clone().subtract(1, 'day')
    const daysArray = [...Array(totalDays)]?.map(() => day.add(1, 'day').clone())
    const isCurrentDay = (day) => moment().isSame(day, 'day')
    const isCurrentMonth = (day) => today.isSame(day, 'month')
    const isSelectedDate = (day) => selectedDate !== null && selectedDate.isSame(day, 'day')

    const dateObjects = events?.map(event => ({
        ...event,
        dateFrom: moment(event.dateFrom),
        dateTo: moment(event.dateTo)
    }));

    const initialSlide = Number((moment().format('D'))) - 2

    const isDateMarked = (day: Moment) => {
        return dateObjects?.some(event => {
            const eventDateFrom = moment(event.dateFrom);
            const eventDateTo = moment(event.dateTo);

            return eventDateFrom.isSameOrBefore(day) && eventDateTo.isSameOrAfter(day);
        });
    }

    const selectDate = (day) => {
        if (selectedDate !== null && selectedDate.isSame(day, 'day')) {
            setSelectedDate(null)
            setTargetDate(null)
        } else {
            setSelectedDate(day)
            setTargetDate(day)
        }
    }

    return (
        <Swiper
            spaceBetween={4}
            initialSlide={initialSlide}
            loop={false}
            slidesPerView={5}
            onBeforeInit={(swiper) => {
                swiperRef.current = swiper;
            }}
            breakpoints={{
                320: {
                    slidesPerView: 6,
                    spaceBetween: 4
                },
                330: {
                    slidesPerView: 6.5,
                    spaceBetween: 4
                },
                340: {
                    slidesPerView: 7,
                    spaceBetween: 4
                },
                370: {
                    slidesPerView: 7.5,
                    spaceBetween: 4
                },
                390: {
                    slidesPerView: 8,
                    spaceBetween: 4
                },
                400: {
                    slidesPerView: 8,
                    spaceBetween: 4
                },
                420: {
                    slidesPerView: 8.5,
                    spaceBetween: 4
                },
                440: {
                    slidesPerView: 9,
                    spaceBetween: 4
                },
                470: {
                    slidesPerView: 9.5,
                    spaceBetween: 4
                }
            }}
        >
            {daysArray && daysArray?.map((date) => (
                <SwiperSlide
                    onClick={() => isDateMarked(date) && isCurrentMonth(date) && selectDate(date)} key={date.format('DDMMYYYY')}
                    className={`calendar__date 
                            ${isCurrentDay(date) && 'calendar__date_today'} 
                            ${isSelectedDate(date) && 'calendar__date_selected'} 
                            ${isCurrentMonth(date) && 'calendar__date_current'}
                            ${isDateMarked(date) && 'calendar__date_marked'}`}
                >
                    <p className={`calendar__date-num`}>{date.format('D')}</p>
                    {isDateMarked(date) && date > new Date() && <div className="calendar__date-dot"></div>}
                </SwiperSlide>
            ))}
        </Swiper>
    )
}

export default CalendarDatesSlider

